export const metamaskAddress = (state) => {
  return state.metamask_address;
};
